import styled, { css } from "styled-components"
import { em } from "polished"

const blockquoteStyles = css`
  /* ${({ theme }) => theme.fonts.set(`secondary`, `normal`)} */

  padding-left: ${em(24)};
  font-style: italic;
  word-break: break-word;
  border-left: 2px solid;

  > * + * {
    margin-top: ${em(20)};
  }

  /* author */

  > footer {
    &::before {
      content: "— ";
    }
  }
`

const Blockquote = styled.blockquote`
  ${blockquoteStyles}
`

export { Blockquote, blockquoteStyles }
